import { render, staticRenderFns } from "./commonProcess.vue?vue&type=template&id=4f237af6&scoped=true"
import script from "./commonProcess.vue?vue&type=script&lang=js"
export * from "./commonProcess.vue?vue&type=script&lang=js"
import style0 from "./commonProcess.vue?vue&type=style&index=0&id=4f237af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f237af6",
  null
  
)

export default component.exports